import React from "react";
import { Typography, Box } from "@material-ui/core";
import useStyles from "./styles";

function getHours(minutes) {
  return parseInt(minutes / 60);
}
function getMinutes(minutes) {
  return minutes - getHours(minutes) * 60;
}

const TimeStats = ({ time }) => {
  const classes = useStyles();
  const hours = getHours(time);
  const minutes = getMinutes(time);

  return (
    <Box className={classes.root}>
      <Typography variant="h4" className={classes.statsLabel}>
        Time spent studying overall:
      </Typography>
      <Box className={classes.timeGroup}>
        <Typography className={classes.timeDescription}>
          <strong className={classes.strong}>{hours}</strong>{" "}
          {hours === 1 ? "hour" : "hours"}
        </Typography>
        <Typography className={classes.timeDescription}>
          <strong className={classes.strong}>{minutes}</strong>{" "}
          {minutes === 1 ? "minute" : "minutes"}
        </Typography>
      </Box>
    </Box>
  );
};

export default TimeStats;
